import type { InsightPost } from "../insights/types";

/** English insight post — extends the Thai InsightPost shape with hreflang pairing. */
export interface EnInsightPost extends Omit<InsightPost, "category"> {
  /** Slug of the Thai counterpart in /insights/<thaiSlug> for hreflang pairing. Optional — not every EN post has a TH twin. */
  thaiSlug?: string;
  category:
    | "notary"
    | "translation"
    | "legalization"
    | "marriage"
    | "visa"
    | "guide";
}

export const EN_INSIGHT_CATEGORY_LABEL: Record<EnInsightPost["category"], string> = {
  notary: "Notary Public",
  translation: "Certified Translation",
  legalization: "MFA / Apostille",
  marriage: "Marriage Registration",
  visa: "Visa & Immigration",
  guide: "Guides",
};